import { render, staticRenderFns } from "./ComCRCard.vue?vue&type=template&id=1cdce92f&scoped=true&"
import script from "./ComCRCard.vue?vue&type=script&lang=js&"
export * from "./ComCRCard.vue?vue&type=script&lang=js&"
import style0 from "./ComCRCard.vue?vue&type=style&index=0&id=1cdce92f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdce92f",
  null
  
)

export default component.exports